export default __webpack_public_path__ + "static/nicholasChancellor-f570097edd6bd612102e8fab5c43abf0.jpg";